import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'manageTemplateTypeList',
})
export class ManageTemplateTypeList implements PipeTransform {
    transform(list: any[], searchText: string): any[] {

        if (!list) {
          return [];
        }
    
        if (!searchText) {
          return list;
        }
    
        searchText = searchText.toLocaleLowerCase();
        let filteredList = [];
        list.forEach((item, index) => {
          if (item.type && item.type.toLocaleLowerCase().includes(searchText)) {
            filteredList.push(item);
          }
        });
    
        return filteredList;
      }
}
